import UtilDateTime from "@/utils/UtilDateTime";

// Status padrão para novos orçamentos: "Em Execução"
export const STATUS_EM_EXECUCAO_ID = "783a5f8a-684f-47f1-a700-a64fb6ab0279";
export const STATUS_EM_EXECUCAO_DESC = "Em Execução";
// Status para quando Job é gerado: "Pedido Colocado"
export const STATUS_PEDIDO_COLOCADO_ID = "18ad60ed-258c-425e-8ecf-3f2afe7d9e05";
export const STATUS_PEDIDO_COLOCADO_DESC = "Pedido Colocado";

export const criarFormularioPadrao = () => ({
  id: null,
  code: "",
  // cabeçalho
  contabilizar: false,
  numeroProposta: "",
  origem: "DELTA DUCON",
  revisao: "",
  ultimaRevisao: "",
  dataCriacao: UtilDateTime.todayISO(),
  dateGenerate: UtilDateTime.todayISO(),
  tipoFaturamento: null,
  tipoDeOrcamento: null,
  tipoDeEquipamento: null,
  tipoDeEquipamentoSigla: "",
  tipoDeEquipamentoDescricao: "",
  job: null,
  jobNome: "",
  // legado / compatibilidade
  numeroSolicitacao: "",
  dataSolicitacao: UtilDateTime.todayISO(),
  status: STATUS_EM_EXECUCAO_ID,
  statusDescription: STATUS_EM_EXECUCAO_DESC,
  // cliente
  cliente: null,
  clienteNome: "",
  clienteCnpj: "",
  referenciaCliente: "",
  cliente_referencia: "",
  vendedor: null,
  vendedorNome: "",
  orcamentista: null,
  orcamentistaNome: "",
  contato: null,
  contatoNome: "",
  contatoTecnico: null,
  contatoTecnicoNome: "",
  contatoTecnicoTelefone: "",
  contatoTecnicoCelular: "",
  contatoTecnicoEmail: "",
  email: "",
  telefone: "",
  contatoComercialTelefone: "",
  contatoComercialCelular: "",
  contatoComercialEmail: "",
  // financeiro
  descricao: "",
  projetoDescricao: "",
  observacao: "",
  prazoResposta: "",
  valorEstimado: "0,00",
  valorDisponivel: "0,00",
  ki: "0,000",
  kidoCusto: "0,00",
  porcentagemPIS: "0,00",
  porcentagemCOFINS: "0,00",
  porcentagemISS: "0,00",
  porcentagemIIS: "0,00",
  porcentagemICMSVenda: "0,00",
  pocentagemIPIVenda: "0,00",
  porcentagemIPI: "0,00",
  precoVenda_sIPI_cICMS: "0,00",
  precoVenda_cIPI_cICMS: "0,00",
  precoVenda_sIPI_sICMS: "0,00",
  precoVenda_cISS: "0,00",
  kv: "0,000",
  valorICMS: "0,00",
  valorIPI: "0,00",
  // proposta tecnica
  projeto: "",
  dataDesejada: "",
  dataDespacho: "",
  dataConclusao: "",
  // sub-entidades (gerenciados localmente no pai)
  itens: []
});

export const criarItemPadrao = () => ({
  itemId: "",
  descricao: "",
  description: "",
  quantidade: 1,
  qty: 1,
  unidade: "",
  dtPrev: "",
  observacao: "",
  obs: "",
  valorDisponivel: "0,00",
  valorDisponivelTotal: "0,00",
  porcentagemPIS: "0,00",
  porcentagemCOFINS: "0,00",
  ki: "0,000",
  kidoCusto: "0,00",
  porcentagemISS: "0,00",
  porcentagemIIS: "0,00",
  porcentagemICMSVenda: "0,00",
  pocentagemIPIVenda: "0,00",
  porcentagemIPI: "0,00",
  kv: "0,000",
  precoVenda_sIPI_cICMS: "0,00",
  precoVenda_cIPI_cICMS: "0,00",
  precoVenda_sIPI_sICMS: "0,00",
  precoVenda_cISS: "0,00",
  valorICMS: "0,00",
  valorIPI: "0,00",
  vlrTotal: "0,00",
  valorTotal: "0,00",
  _mirror_valor_sIPI_cICMS: "0,00"
});

export const normalizarItem = (item = {}) => ({
  itemId: item.itemId || item.item || "",
  descricao: item.descricao || item.description || "",
  description: item.description || item.descricao || "",
  quantidade: item.quantidade !== undefined ? item.quantidade : (item.qty !== undefined ? item.qty : 1),
  qty: item.qty !== undefined ? item.qty : (item.quantidade !== undefined ? item.quantidade : 1),
  unidade: item.unidade || "",
  dtPrev: item.dtPrev || "",
  observacao: item.observacao || item.obs || "",
  obs: item.obs || item.observacao || "",
  valorDisponivel: item.valorDisponivel !== undefined ? item.valorDisponivel : "0,00",
  valorDisponivelTotal: item.valorDisponivelTotal !== undefined
    ? item.valorDisponivelTotal
    : formatarNumeroInput(parseNumero(item.quantidade ?? item.qty ?? 1) * parseNumero(item.valorDisponivel ?? 0)),
  porcentagemPIS: item.porcentagemPIS !== undefined ? item.porcentagemPIS : "0,00",
  porcentagemCOFINS: item.porcentagemCOFINS !== undefined ? item.porcentagemCOFINS : "0,00",
  ki: item.ki !== undefined ? item.ki : "0,000",
  kidoCusto: item.kidoCusto !== undefined ? item.kidoCusto : "0,00",
  porcentagemISS: item.porcentagemISS !== undefined ? item.porcentagemISS : (item.porcentagemIIS !== undefined ? item.porcentagemIIS : "0,00"),
  porcentagemIIS: item.porcentagemIIS !== undefined ? item.porcentagemIIS : (item.porcentagemISS !== undefined ? item.porcentagemISS : "0,00"),
  porcentagemICMSVenda: item.porcentagemICMSVenda !== undefined ? item.porcentagemICMSVenda : "0,00",
  pocentagemIPIVenda: item.pocentagemIPIVenda !== undefined ? item.pocentagemIPIVenda : (item.porcentagemIPI !== undefined ? item.porcentagemIPI : "0,00"),
  porcentagemIPI: item.porcentagemIPI !== undefined ? item.porcentagemIPI : (item.pocentagemIPIVenda !== undefined ? item.pocentagemIPIVenda : "0,00"),
  kv: item.kv !== undefined ? item.kv : "0,000",
  precoVenda_sIPI_cICMS: item.precoVenda_sIPI_cICMS !== undefined ? item.precoVenda_sIPI_cICMS : "0,00",
  precoVenda_cIPI_cICMS: item.precoVenda_cIPI_cICMS !== undefined ? item.precoVenda_cIPI_cICMS : "0,00",
  precoVenda_sIPI_sICMS: item.precoVenda_sIPI_sICMS !== undefined ? item.precoVenda_sIPI_sICMS : "0,00",
  precoVenda_cISS: item.precoVenda_cISS !== undefined ? item.precoVenda_cISS : "0,00",
  valorICMS: item.valorICMS !== undefined ? item.valorICMS : "0,00",
  valorIPI: item.valorIPI !== undefined ? item.valorIPI : "0,00",
  vlrTotal: item.vlrTotal !== undefined ? item.vlrTotal : "0,00",
  valorTotal: item.valorTotal !== undefined ? item.valorTotal : "0,00",
  _mirror_valor_sIPI_cICMS: item._mirror_valor_sIPI_cICMS !== undefined ? item._mirror_valor_sIPI_cICMS : "0,00"
});

export const calcularValorTotalItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade);
  const preco = parseNumero(item.precoVenda_sIPI_cICMS);
  return Number((quantidade * preco).toFixed(2));
};

export const calcularValorDisponivelTotalItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade ?? item.qty);
  const valorDisponivel = parseNumero(item.valorDisponivel);
  return Number((quantidade * valorDisponivel).toFixed(2));
};

export const calcularCamposDeItens = (itens = []) => {
  if (!Array.isArray(itens) || itens.length === 0) return null;

  const soma = itens.reduce((acc, item) => {
    const valorTotalItem = calcularValorTotalItem(item);
    acc.precoVenda_sIPI_cICMS += valorTotalItem;
    
    // Calcula impostos como percentual sobre o valor total do item (já considerando quantidade)
    const porcentagemICMS = parseNumero(item.porcentagemICMSVenda);
    const porcentagemIPI = parseNumero(item.porcentagemIPI);
    
    acc.valorICMS += (valorTotalItem * porcentagemICMS) / 100;
    acc.valorIPI += (valorTotalItem * porcentagemIPI) / 100;
    
    acc.valorDisponivel += parseNumero(item.valorDisponivelTotal ?? calcularValorDisponivelTotalItem(item));
    return acc;
  }, { precoVenda_sIPI_cICMS: 0, valorICMS: 0, valorIPI: 0, valorDisponivel: 0 });

  return {
    precoVenda_sIPI_cICMS: formatarNumeroInput(soma.precoVenda_sIPI_cICMS),
    precoVenda_cIPI_cICMS: formatarNumeroInput(soma.precoVenda_sIPI_cICMS + soma.valorIPI),
    valorICMS: formatarNumeroInput(soma.valorICMS),
    valorIPI: formatarNumeroInput(soma.valorIPI),
    valorDisponivel: formatarNumeroInput(soma.valorDisponivel)
  };
};

export const parseNumero = (valor) => {
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
  if (valor === null || valor === undefined || valor === "") return 0;
  const texto = String(valor).trim();
  const textoNormalizado = texto
    .replace(/\s/g, "")
    .replace(/(\d)\.(?=\d{3}(\D|$))/g, "$1")
    .replace(",", ".");
  const numero = Number(textoNormalizado);
  return Number.isFinite(numero) ? numero : 0;
};

export const formatarNumeroInput = (valor, casas = 2) => {
  const numero = parseNumero(valor);
  return Number(numero).toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas
  });
};

export const formatarKv = (valor) => {
  return parseNumero(valor).toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
};

export const recalcularCamposPreco = (formulario = {}) => {
  const valorDisponivel = parseNumero(formulario.valorDisponivel);
  const ki = parseNumero(formulario.ki);
  const porcentagemICMSVenda = parseNumero(formulario.porcentagemICMSVenda);
  const porcentagemISS = parseNumero(formulario.porcentagemISS || formulario.porcentagemIIS);
  const precoVendaComIcms = parseNumero(formulario.precoVenda_sIPI_cICMS);

  let precoVendaSemIcms = precoVendaComIcms;
  if (porcentagemICMSVenda > 0) {
    precoVendaSemIcms = precoVendaComIcms - ((porcentagemICMSVenda / 100) * precoVendaComIcms);
  }

  let precoVendaComIss = precoVendaSemIcms;
  if (porcentagemISS > 0) {
    precoVendaComIss = precoVendaSemIcms + ((porcentagemISS / 100) * precoVendaSemIcms);
  }

  let kiDoCusto = 0;
  if (precoVendaComIcms !== 0 && ki !== 0) {
    kiDoCusto = precoVendaComIcms * ki;
  }

  const kv = kiDoCusto !== 0 ? (valorDisponivel / kiDoCusto) : 0;
  const valorIPI = parseNumero(formulario.valorIPI);

  return {
    precoVenda_cIPI_cICMS: formatarNumeroInput(Number((precoVendaComIcms + valorIPI).toFixed(2))),
    precoVenda_sIPI_sICMS: formatarNumeroInput(Number(precoVendaSemIcms.toFixed(2))),
    precoVenda_cISS: formatarNumeroInput(Number(precoVendaComIss.toFixed(2))),
    kidoCusto: formatarNumeroInput(Number(kiDoCusto.toFixed(2))),
    kv: formatarKv(kv)
  };
};

export const recalcularCamposComerciaisItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade ?? item.qty);
  const valorDisponivel = parseNumero(item.valorDisponivel);
  const ki = parseNumero(item.ki);
  const porcentagemICMSVenda = parseNumero(item.porcentagemICMSVenda);
  const porcentagemISS = parseNumero(item.porcentagemISS || item.porcentagemIIS);
  const porcentagemIPI = parseNumero(item.pocentagemIPIVenda || item.porcentagemIPI);
  const precoVendaComIcms = parseNumero(item.precoVenda_sIPI_cICMS);

  const valorICMS = Number(((porcentagemICMSVenda / 100) * precoVendaComIcms).toFixed(2));
  const valorIPI = Number(((porcentagemIPI / 100) * precoVendaComIcms).toFixed(2));
  const precoVendaComIpi = Number((precoVendaComIcms + valorIPI).toFixed(2));

  let precoVendaSemIcms = precoVendaComIcms;
  if (porcentagemICMSVenda > 0) {
    precoVendaSemIcms = precoVendaComIcms - valorICMS;
  }

  let precoVendaComIss = precoVendaSemIcms;
  if (porcentagemISS > 0) {
    precoVendaComIss = precoVendaSemIcms + ((porcentagemISS / 100) * precoVendaSemIcms);
  }

  let kiDoCusto = 0;
  if (precoVendaComIcms !== 0 && ki !== 0) {
    kiDoCusto = precoVendaComIcms * ki;
  }

  const kv = kiDoCusto !== 0 ? (valorDisponivel / kiDoCusto) : 0;
  const vlrTotal = Number((quantidade * precoVendaComIcms).toFixed(2));
  const valorDisponivelTotal = Number((quantidade * valorDisponivel).toFixed(2));

  return {
    quantidade: quantidade || 0,
    qty: quantidade || 0,
    valorICMS: formatarNumeroInput(valorICMS),
    valorIPI: formatarNumeroInput(valorIPI),
    precoVenda_cIPI_cICMS: formatarNumeroInput(precoVendaComIpi),
    precoVenda_sIPI_sICMS: formatarNumeroInput(Number(precoVendaSemIcms.toFixed(2))),
    precoVenda_cISS: formatarNumeroInput(Number(precoVendaComIss.toFixed(2))),
    kidoCusto: formatarNumeroInput(Number(kiDoCusto.toFixed(2))),
    kv: formatarKv(kv),
    vlrTotal: formatarNumeroInput(vlrTotal),
    valorTotal: formatarNumeroInput(vlrTotal),
    valorDisponivelTotal: formatarNumeroInput(valorDisponivelTotal),
    _mirror_valor_sIPI_cICMS: formatarNumeroInput(valorDisponivel)
  };
};

export const normalizaItemSalesOrder = (item = {}, statusDescricaoPorId = {}) => {
  const referenciaClienteValor = String(item.cliente_referencia ?? item.referenciaCliente ?? "").trim();
  const statusId = typeof item.status === "object" ? item.status?.id : item.status;
  const statusDescription =
    item.statusDescription ||
    item.status?.description ||
    statusDescricaoPorId[statusId] ||
    "Sem status";

  const clienteId =
    typeof item.cliente === "object"
      ? item.cliente?.id
      : item.cliente || item.clienteID || null;

  const contatoId =
    (typeof item.contatoComercial === "object"
      ? item.contatoComercial?.id
      : item.contatoComercial) ||
    (typeof item.contato === "object"
      ? item.contato?.id
      : item.contato) ||
    null;

  const contatoTecnicoId =
    typeof item.contatoTecnico === "object"
      ? item.contatoTecnico?.id
      : item.contatoTecnico || null;

  const valorDisponivel = item.valorDisponivel ?? item.revisoes?.valorDisponivel ?? 0;
  const ki = item.ki ?? item.revisoes?.ki ?? 0;
  const kidoCusto = item.kidoCusto ?? item.revisoes?.kidoCusto ?? 0;
  const porcentagemICMSVenda = item.porcentagemICMSVenda ?? item.revisoes?.porcentagemICMSVenda ?? "0";
  const precoVenda_sIPI_cICMS =
    item.precoVenda_sIPI_cICMS ??
    item.revisoes?.precoVenda_sIPI_cICMS ??
    item._mirror_valor_sIPI_cICMS ??
    0;
  const precoVenda_sIPI_sICMS = item.precoVenda_sIPI_sICMS ?? item.revisoes?.precoVenda_sIPI_sICMS ?? 0;
  const kv = item.kv ?? item.revisoes?.kv ?? "0,000";
  const sigla =
    item._mirror_tipo ||
    (typeof item.sigla === "object"
      ? item.sigla?.descricao || item.sigla?.description || item.sigla?.nome || item.sigla?.name || item.sigla?.codigo
      : item.sigla) ||
    (typeof item.origem === "object"
      ? item.origem?.descricao || item.origem?.description || item.origem?.nome || item.origem?.name || item.origem?.codigo
      : item.origem) ||
    (typeof item._mirror_tipoDeEquipamento === "object"
      ? item._mirror_tipoDeEquipamento?.descricao ||
        item._mirror_tipoDeEquipamento?.description ||
        item._mirror_tipoDeEquipamento?.nome ||
        item._mirror_tipoDeEquipamento?.name ||
        item._mirror_tipoDeEquipamento?.codigo
      : item._mirror_tipoDeEquipamento) ||
    "";

  return {
    ...item,
    id: item.id || item._id || item.code,
    sigla,
    code: item.code || item.codigo || item.numeroSolicitacao || "",
    numeroProposta: item.numeroProposta || item.numeroSolicitacao || item.codigo || item.code || "",
    numeroSolicitacao: item.numeroSolicitacao || item.codigo || item.code || "",
    cliente: clienteId,
    clienteCodigo:
      item.clienteCodigo ||
      item.cliente?.codigo ||
      item.cliente?.code ||
      item.customerCode ||
      item.clienteCode ||
      "",
    clienteNome: item.clienteNome || item.cliente?.nomeFantasia || item.credorNome || item.customerName || "",
    contato: contatoId,
    contatoComercial: contatoId,
    contatoNome: item.contatoComercialNome || item.contato?.nome || item.contatoComercial?.nome || "",
    contatoTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialCelular: item.contatoComercialCelular || item.contato?.celular || item.contatoComercial?.celular || "",
    contatoComercialEmail: item.contatoComercialEmail || item.contato?.email || item.contatoComercial?.email || "",
    contatoTecnico: contatoTecnicoId,
    contatoTecnicoNome: item.contatoTecnicoNome || item.contatoTecnico?.nome || item.contatoTecnicoName || "",
    contatoTecnicoTelefone: item.contatoTecnicoTelefone || item.contatoTecnico?.telefone || "",
    contatoTecnicoCelular: item.contatoTecnicoCelular || item.contatoTecnico?.celular || "",
    contatoTecnicoEmail: item.contatoTecnicoEmail || item.contatoTecnico?.email || "",
    cliente_referencia: referenciaClienteValor,
    referenciaCliente: referenciaClienteValor,
    revisao: item.revisao || item.version || "",
    ultimaRevisao: item.ultimaRevisao || item.version || item.revisao || "",
    dateGenerate: item.dateGenerate || item.dataGeracao || "",
    dataCriacao: item.dataCriacao || item.createdAt || item.dateGenerate || item.dataSolicitacao || "",
    tipoFaturamento: item.tipoFaturamento || item.tipoDeOrcamento || null,
    tipoDeOrcamento: item.tipoDeOrcamento || item.tipoFaturamento || null,
    contatoEmail: item.contatoComercialEmail || item.contatoComercial?.email || "",
    dataSolicitacao:
      item.dataSolicitacao ||
      item.createdAt ||
      item.dataCadastro ||
      item.dataEmissao ||
      "",
    dataDesejada: item.dataDesejada || item._mirror_dataDesejada || item.dataDespacho || "",
    status: statusId || item.status || null,
    statusDescription,
    valorEstimado:
      Number(
        item.valorEstimado ??
        item._mirror_valor_sIPI_cICMS ??
        item.valor ??
        item.total ??
        0
      ) || 0,
    valorDisponivel,
    ki,
    kidoCusto,
    porcentagemPIS: item.porcentagemPIS ?? "0",
    porcentagemCOFINS: item.porcentagemCOFINS ?? "0",
    porcentagemISS: item.porcentagemISS ?? item.porcentagemIIS ?? "0",
    porcentagemIIS: item.porcentagemIIS ?? "0",
    porcentagemICMSVenda,
    pocentagemIPIVenda: item.pocentagemIPIVenda ?? item.porcentagemIPI ?? "0",
    porcentagemIPI: item.porcentagemIPI ?? "0",
    precoVenda_sIPI_cICMS,
    precoVenda_cIPI_cICMS: item.precoVenda_cIPI_cICMS ?? (parseNumero(precoVenda_sIPI_cICMS) + parseNumero(item.valorIPI)),
    precoVenda_sIPI_sICMS,
    precoVenda_cISS: item.precoVenda_cISS ?? 0,
    kv,
    descricao: item.projetoDescricao || item.descricao || item._mirror_projeto || "",
    projetoDescricao: item.projetoDescricao || item.descricao || item._mirror_projeto || "",
    projeto: item.projetoDescricao || item.projeto || item._mirror_projeto || "",
    observacao: item.observacao || item.observacoes || "",
    dataDespacho: item.dataDespacho || item.dataDesejada || item._mirror_dataDesejada || "",
    dataConclusao: item.dataConclusao || "",
    _mirror_tipoDeEquipamento: item._mirror_tipoDeEquipamento || "",
    _mirror_projeto: item._mirror_projeto || item.projetoDescricao || item.descricao || "",
    _mirror_dataSolicitacao: item._mirror_dataSolicitacao || item.dataSolicitacao || "",
    _mirror_dataDesejada: item._mirror_dataDesejada || item.dataDesejada || item.dataDespacho || "",
    _mirror_dataConclusao: item._mirror_dataConclusao || item.dataConclusao || "",
    tipoDeEquipamento:
      (typeof item.tipoDeEquipamento === "object" ? item.tipoDeEquipamento?.id : item.tipoDeEquipamento) || null,
    tipoDeEquipamentoSigla:
      item.tipoDeEquipamentoSigla ||
      item.tipoDeEquipamento?.sigla ||
      item.tipoDeEquipamento?.codigo ||
      item.tipoDeEquipamento?.code ||
      "",
    tipoDeEquipamentoDescricao:
      item.tipoDeEquipamentoDescricao ||
      item.tipoDeEquipamento?.descricao ||
      item.tipoDeEquipamento?.nome ||
      item.tipoDeEquipamento?.description ||
      "",
    itens: Array.isArray(item.itens) ? item.itens : (Array.isArray(item.Itens) ? item.Itens : [])
  };
};

export const normalizaListaSalesOrder = (response, statusDescricaoPorId = {}) => {
  const lista =
    response?.data?.data?.data ||
    response?.data?.data ||
    response?.data ||
    [];

  if (!Array.isArray(lista)) return [];
  return lista.map((item) => normalizaItemSalesOrder(item, statusDescricaoPorId));
};

export const gerarPayloadPersistencia = (formulario = {}) => {
  const referenciaClienteValor = String(formulario.cliente_referencia ?? formulario.referenciaCliente ?? "").trim();
  const projetoDescricao = formulario.projetoDescricao || formulario.descricao || formulario.projeto || "";
  const dataDesejada = formulario.dataDesejada || formulario.dataDespacho || "";
  const tipoDeOrcamento = formulario.tipoDeOrcamento || formulario.tipoFaturamento || null;
  const dateGenerateUTC = formulario.dateGenerate
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dateGenerate })
    : UtilDateTime.todayUTC();
  const dataCriacaoUTC = formulario.dataCriacao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataCriacao })
    : UtilDateTime.todayUTC();
  const dataSolicitacaoUTC = formulario.dataSolicitacao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataSolicitacao })
    : UtilDateTime.todayUTC();
  const dataDesejadaUTC = dataDesejada
    ? UtilDateTime.toFormatUTC({ dateTime: dataDesejada })
    : "";
  const dataConclusaoUTC = formulario.dataConclusao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataConclusao })
    : "";

  return {
    ...formulario,
    // Garante persistência correta dos campos ao gravar/editar/concluir, sem duplicar chaves
    origem: formulario.origem || "DELTA DUCON",
    cliente_referencia: referenciaClienteValor,
    referenciaCliente: referenciaClienteValor,
    contatoComercial: formulario.contato || formulario.contatoComercial || null,
    contatoTecnico: formulario.contatoTecnico || null,
    contatoComercialTelefone: formulario.contatoComercialTelefone || formulario.telefone || "",
    contatoComercialCelular: formulario.contatoComercialCelular || "",
    contatoComercialEmail: formulario.contatoComercialEmail || formulario.email || "",
    contatoTecnicoNome: formulario.contatoTecnicoNome || "",
    contatoTecnicoTelefone: formulario.contatoTecnicoTelefone || "",
    contatoTecnicoCelular: formulario.contatoTecnicoCelular || "",
    contatoTecnicoEmail: formulario.contatoTecnicoEmail || "",
    valorEstimado: Number(formulario.valorEstimado || 0),
    valorDisponivel: parseNumero(formulario.valorDisponivel),
    ki: parseNumero(formulario.ki),
    kidoCusto: parseNumero(formulario.kidoCusto),
    porcentagemPIS: parseNumero(formulario.porcentagemPIS),
    porcentagemCOFINS: parseNumero(formulario.porcentagemCOFINS),
    porcentagemISS: parseNumero(formulario.porcentagemISS || formulario.porcentagemIIS),
    porcentagemIIS: parseNumero(formulario.porcentagemIIS),
    porcentagemICMSVenda: parseNumero(formulario.porcentagemICMSVenda),
    pocentagemIPIVenda: parseNumero(formulario.pocentagemIPIVenda || formulario.porcentagemIPI),
    porcentagemIPI: parseNumero(formulario.porcentagemIPI),
    precoVenda_sIPI_cICMS: parseNumero(formulario.precoVenda_sIPI_cICMS),
    precoVenda_cIPI_cICMS: parseNumero(formulario.precoVenda_cIPI_cICMS),
    precoVenda_sIPI_sICMS: parseNumero(formulario.precoVenda_sIPI_sICMS),
    precoVenda_cISS: parseNumero(formulario.precoVenda_cISS),
    kv: parseNumero(formulario.kv),
    valorICMS: parseNumero(formulario.valorICMS),
    valorIPI: parseNumero(formulario.valorIPI),
    tipoDeOrcamento,
    tipoFaturamento: tipoDeOrcamento,
    descricao: projetoDescricao,
    projetoDescricao,
    projeto: projetoDescricao,
    observacao: String(formulario.observacao ?? formulario.observacoes ?? ""),
    dateGenerate: dateGenerateUTC,
    dataCriacao: dataCriacaoUTC,
    dataSolicitacao: dataSolicitacaoUTC,
    dataDesejada: dataDesejadaUTC,
    dataDespacho: dataDesejadaUTC,
    dataConclusao: dataConclusaoUTC,
    _mirror_projeto: projetoDescricao,
    _mirror_dataSolicitacao: dataSolicitacaoUTC,
    _mirror_dataDesejada: dataDesejadaUTC,
    _mirror_dataConclusao: dataConclusaoUTC,
    _mirror_valor_sIPI_cICMS: parseNumero(formulario.precoVenda_sIPI_cICMS),
    tipoDeEquipamento: formulario.tipoDeEquipamento || null,
    tipoDeEquipamentoSigla: formulario.tipoDeEquipamentoSigla || "",
    tipoDeEquipamentoDescricao: formulario.tipoDeEquipamentoDescricao || "",
    itens: Array.isArray(formulario.itens) ? formulario.itens.map((item) => ({
      ...item,
      itemId: item.itemId || item.item || null,
      description: item.description || item.descricao || "",
      descricao: item.descricao || item.description || "",
      qty: parseNumero(item.qty ?? item.quantidade),
      quantidade: parseNumero(item.quantidade ?? item.qty),
      dtPrev: item.dtPrev || "",
      obs: item.obs || item.observacao || "",
      observacao: item.observacao || item.obs || "",
      valorDisponivel: parseNumero(item.valorDisponivel),
      valorDisponivelTotal: parseNumero(item.valorDisponivelTotal ?? calcularValorDisponivelTotalItem(item)),
      porcentagemPIS: parseNumero(item.porcentagemPIS),
      porcentagemCOFINS: parseNumero(item.porcentagemCOFINS),
      ki: parseNumero(item.ki),
      kidoCusto: parseNumero(item.kidoCusto),
      porcentagemISS: parseNumero(item.porcentagemISS || item.porcentagemIIS),
      porcentagemIIS: parseNumero(item.porcentagemIIS || item.porcentagemISS),
      porcentagemICMSVenda: parseNumero(item.porcentagemICMSVenda),
      pocentagemIPIVenda: parseNumero(item.pocentagemIPIVenda || item.porcentagemIPI),
      porcentagemIPI: parseNumero(item.porcentagemIPI || item.pocentagemIPIVenda),
      kv: parseNumero(item.kv),
      precoVenda_sIPI_cICMS: parseNumero(item.precoVenda_sIPI_cICMS),
      precoVenda_cIPI_cICMS: parseNumero(item.precoVenda_cIPI_cICMS),
      precoVenda_sIPI_sICMS: parseNumero(item.precoVenda_sIPI_sICMS),
      precoVenda_cISS: parseNumero(item.precoVenda_cISS),
      valorICMS: parseNumero(item.valorICMS),
      valorIPI: parseNumero(item.valorIPI),
      vlrTotal: parseNumero(item.vlrTotal || item.valorTotal || calcularValorTotalItem(item)),
      valorTotal: calcularValorTotalItem(item),
      _mirror_valor_sIPI_cICMS: parseNumero(item._mirror_valor_sIPI_cICMS || 0)
    })) : []
  };
};